/**
 * Extract the root domain from a hostname.
 *
 * "www.sub.example.com" → "example.com"
 * "example.co.uk"       → "example.co.uk"
 * "localhost"            → "localhost"
 */

const TWO_PART_TLDS = new Set([
  "co.uk",
  "co.jp",
  "co.kr",
  "co.nz",
  "co.za",
  "co.in",
  "com.br",
  "com.au",
  "com.ar",
  "com.mx",
  "com.tr",
  "com.cn",
  "com.sg",
  "com.hk",
  "com.tw",
  "org.uk",
  "org.au",
  "net.au",
  "net.br",
  "gov.br",
  "ac.uk",
]);

export function extractRootDomain(hostname: string): string {
  const parts = hostname.toLowerCase().replace(/\.$/, "").split(".");

  if (parts.length <= 2) {
    return parts.join(".");
  }

  const lastTwo = `${parts[parts.length - 2]}.${parts[parts.length - 1]}`;
  if (TWO_PART_TLDS.has(lastTwo)) {
    return parts.slice(-3).join(".");
  }

  return parts.slice(-2).join(".");
}
